import { useTranslation } from "react-i18next";
import { Form, Icon } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";

import type { User } from "models";

const FormHelper = createFormHelper<User>();

export const OrderStatusSection = () => {
  const { t } = useTranslation();

  return (
    <div className="setting_section role_order">
      <div>
        <h3 className="section-title">{t("v8_order_status", "Order Status")}</h3>
        <div className="FormSection">
          <Form.Group className="ShoppingCart-container">
            <FormHelper.Field.Checkbox
              name="shop_status_same_day_filter_enabled"
              label={
                <label>
                  <Icon className="shopping cart same-day" /> {t("v8_shopping_cart_same_day", "Same Day")}
                </label>
              }
            />
            <FormHelper.Field.Checkbox
              name="shop_status_to_order_filter_enabled"
              label={
                <label>
                  <Icon className="shopping cart to-order" /> {t("v8_shopping_cart_to_order", "To Order")}
                </label>
              }
            />
            <FormHelper.Field.Checkbox
              name="shop_status_arrived_parts_filter_enabled"
              label={
                <label>
                  <Icon className="shopping cart arrived" /> {t("v8_parts_arrived", "Parts arrived")}
                </label>
              }
            />
            <FormHelper.Field.Checkbox
              name="shop_status_next_day_filter_enabled"
              label={
                <label>
                  <Icon className="shopping cart tomorrow" /> {t("v8_shopping_cart_tomorrow", "Tomorrow")}
                </label>
              }
            />
            <FormHelper.Field.Checkbox
              name="shop_status_backorder_filter_enabled"
              label={
                <label>
                  <Icon className="shopping cart backorder" /> {t("v8_shopping_cart_backorder", "Backorder")}
                </label>
              }
            />
          </Form.Group>
        </div>
      </div>
    </div>
  );
};
